<template>
  <div>
    <!-- 内容区 -->
    <div class="content">
      <!-- 筛选区 -->
      <div class="filtrate w">
        <dl>
          <dt>品牌</dt>
          <dd>
            <div class="left">
              <img @click="chooseParams('brand', item.id)" class="active" v-for="(item, index) in hotBrands" :key="index" :src="item.logoImg" alt="" />
            </div>
            <div class="right">
              <el-select size="mini" v-model="brand" placeholder="请选择品牌">
                <el-option v-for="item in brandList" :key="item.value" :label="item.name" :value="item.id"> </el-option>
              </el-select>
              <span>-</span>
              <el-select size="mini" v-model="series" placeholder="请选择车系">
                <el-option v-for="item in seriesList" :key="item.value" :label="item.name" :value="item.id"> </el-option>
              </el-select>
            </div>
          </dd>
        </dl>
        <dl>
          <dt>价格</dt>
          <dd>
            <div class="left">
              <span :class="{ active: price == item.value }" @click="chooseParams('price', item.value)" v-for="item in priceList" :key="item.value">{{ item.text }}</span>
            </div>
            <div class="right">
              <div>
                <el-input style="width:100px" size="mini" type="text" placeholder="请输入内容" v-model="priceLow"> </el-input>
              </div>
              <span>-</span>
              <div>
                <el-input style="width:100px" size="mini" type="text" placeholder="请输入内容" v-model="priceHigh"> </el-input>
              </div>
              <p>万元</p>
              <div class="btn2" @click="submit">确认</div>
            </div>
          </dd>
        </dl>
        <dl>
          <dt>车型</dt>
          <dd>
            <div class="left">
              <span :class="{ active: vehicleType == item.value }" @click="chooseParams('vehicleType', item.value)" v-for="item in vehicleTypeList" :key="item.value">{{ item.text }}</span>
            </div>
          </dd>
        </dl>
        <dl>
          <dt>里程</dt>
          <dd>
            <div class="left">
              <span :class="{ active: mileage == item.value }" @click="chooseParams('mileage', item.value)" v-for="item in mileageList" :key="item.value">{{ item.text }}</span>
            </div>
            <div class="right">
              <div>
                <el-input style="width:100px" size="mini" type="text" placeholder="请输入内容" v-model="mileageCountLow"> </el-input>
              </div>
              <span>-</span>
              <div>
                <el-input style="width:100px" size="mini" type="text" placeholder="请输入内容" v-model="mileageCountHigh"> </el-input>
              </div>
              <p>万公里</p>
              <div class="btn2" @click="submit">确认</div>
            </div>
          </dd>
        </dl>
        <dl>
          <dt>车龄</dt>
          <dd>
            <div class="left">
              <span :class="{ active: carAge == item.value }" @click="chooseParams('carAge', item.value)" v-for="item in carAgeList" :key="item.value">{{ item.text }}</span>
            </div>
            <div class="right">
              <div>
                <el-input style="width:100px" size="mini" type="text" placeholder="请输入内容" v-model="carAgeLow"> </el-input>
              </div>
              <span>-</span>
              <div>
                <el-input style="width:100px" size="mini" type="text" placeholder="请输入内容" v-model="carAgeHigh"> </el-input>
              </div>
              <p>年</p>
              <div class="btn2" @click="submit">确认</div>
            </div>
          </dd>
        </dl>
        <!-- <dl>
          <dt>变速箱</dt>
          <dd>
            <div class="left">
              <span :class="{ active: state == item.value }" @click="chooseParams(item.value)" v-for="item in carStateList" :key="item.seriesId">{{ item.text }}</span>
            </div>
          </dd>
        </dl>-->
        <dl>
          <dt>专区</dt>
          <dd>
            <div class="left">
              <span :class="{ active: certifyTag == item.value }" @click="chooseParams('certifyTag', item.value)" v-for="item in certifyTagList" :key="item.value">{{ item.text }}</span>
            </div>
          </dd>
        </dl>
      </div>

      <!-- 当前选择 -->
      <div
        class="current_choose w"
        v-if="keyword || brand || series || price || vehicleType || mileage || carAge || certifyTag || priceLow || priceHigh || carAgeLow || carAgeHigh || mileageCountLow || mileageCountHigh"
      >
        <div class="title">当前选择：</div>
        <div class="current_content">
          <div class="choose_box" v-if="brand !== ''">
            <div>品牌：{{ brandName || '' }}</div>
            <div @click="close('brand')">X</div>
          </div>
          <div class="choose_box" v-if="series !== ''">
            <div>车系：{{ seriesList[seriesList.findIndex(item => item.id == series)].name || '' }}</div>
            <div @click="close('series')">X</div>
          </div>
          <div class="choose_box" v-if="price != ''">
            <div>价格：{{ priceName || '' }}</div>
            <div @click="close('price')">X</div>
          </div>
          <div class="choose_box" v-if="priceLow != ''">
            <div>最低价格：{{ priceLow }}万元</div>
            <div @click="close('priceLow')">X</div>
          </div>
          <div class="choose_box" v-if="priceHigh != ''">
            <div>最高价格：{{ priceHigh }}万元</div>
            <div @click="close('priceHigh')">X</div>
          </div>
          <div class="choose_box" v-if="vehicleType != ''">
            <div>车型：{{ vehicleTypeName || '' }}</div>
            <div @click="close('vehicleType')">X</div>
          </div>
          <div class="choose_box" v-if="carAge != ''">
            <div>车龄：{{ carAgeList[carAgeList.findIndex(item => item.value == carAge)].text || '' }}</div>
            <div @click="close('carAge')">X</div>
          </div>
          <div class="choose_box" v-if="carAgeLow != ''">
            <div>最低车龄：{{ carAgeLow }}年</div>
            <div @click="close('carAgeLow')">X</div>
          </div>
          <div class="choose_box" v-if="carAgeHigh != ''">
            <div>最高车龄：{{ carAgeHigh }}年</div>
            <div @click="close('carAgeHigh')">X</div>
          </div>
          <div class="choose_box" v-if="mileage != ''">
            <div>里程：{{ mileageList[mileageList.findIndex(item => item.value == mileage)].text || '' }}</div>
            <div @click="close('mileage')">X</div>
          </div>
          <div class="choose_box" v-if="mileageCountLow != ''">
            <div>最低里程：{{ mileageCountLow }}万公里</div>
            <div @click="close('mileageCountLow')">X</div>
          </div>
          <div class="choose_box" v-if="mileageCountHigh != ''">
            <div>最高里程：{{ mileageCountHigh }}万公里</div>
            <div @click="close('mileageCountHigh')">X</div>
          </div>
          <div class="choose_box" v-if="certifyTag != ''">
            <div>专区：{{ certifyTagName }}</div>
            <div @click="close('certifyTag')">X</div>
          </div>
          <div class="choose_box" v-if="keyword != ''">
            <div>搜索：{{ keyword || '' }}</div>
            <div @click="close('keyword')">X</div>
          </div>

          <div class="close_all" @click="closeAll()">清空全部</div>
        </div>
      </div>

      <!-- 车辆列表 -->
      <div class="car_list w">
        <div class="sort">
          <div class="sort_text" :class="{ active2: orders == 0 }" @click="chooseOrders('total')"><span>综合</span></div>
          <div class="sort_text" :class="{ active2: orders == 1 || orders == 2 }" @click="chooseOrders('new')">
            <span>最新</span>
            <span><i :class="{ 'el-icon-top': orders != 2, 'el-icon-bottom': orders == 2 }"></i></span>
          </div>
          <div class="sort_text" :class="{ active2: orders == 3 || orders == 4 }" @click="chooseOrders('price')">
            <span>标价</span>
            <span><i :class="{ 'el-icon-top': orders != 4, 'el-icon-bottom': orders == 4 }"></i></span>
          </div>
          <div class="sort_text" :class="{ active2: orders == 5 || orders == 6 }" @click="chooseOrders('mileage')">
            <span>里程</span>
            <span><i :class="{ 'el-icon-top': orders != 6, 'el-icon-bottom': orders == 6 }"></i></span>
          </div>
        </div>
        <div class="car_content">
          <el-row :gutter="25">
            <el-col :span="6" v-for="item in vehicleList" :key="item.vehicleId">
              <div class="car_box" @click="toCarDetail(item.tradeId)">
                <!-- <img :src="imgUrl" class="imgUrl" v-if="item.certifyTag == 1" /> -->
                <div class="car_img">
                  <img v-if="item.coverUrl" :src="item.coverUrl" alt="" />
                  <img v-else src="../assets/img/default-car.png" alt="" />
                </div>
                <div class="car_name">{{ item.vehicleName }}</div>
                <div class="car_text">
                  <span v-if="item.registMonth">{{ item.registMonth }} </span>
                  <span v-if="item.mileageCount">{{ item.mileageCount }}万公里</span>
                </div>
                <div class="car_price">
                  <span class="dealDate" v-if="item.showPrice">{{ item.showPrice }}万</span>
                  <span v-if="item.downPayments">￥首付{{ item.downPayments }}万</span>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <!-- 分页 -->
      <div class="car_list w">
        <div class="page_box">
          <el-pagination
            @prev-click="prevPage"
            @next-click="nextPage"
            @current-change="handleCurrentChange"
            :current-page.sync="pageNo"
            :page-size="pageSize"
            layout="prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import menus from '../utils/menu'
export default {
  props: ['city'],
  data() {
    return {
      manuActive: 2,
      pageNo: 1,
      pageSize: 12,
      orders: 0,
      keyword: '',
      price: 0,
      priceLow: '',
      priceHigh: '',
      vehicleType: 0,
      mileage: 0,
      mileageCountLow: '',
      mileageCountHigh: '',
      carAge: 0,
      carAgeLow: '',
      carAgeHigh: '',
      certifyTag: 0,
      brand: '',
      series: '',
      ordersList: [],
      carAgeList: [],
      mileageList: [],
      priceList: [],
      certifyTagList: [],
      vehicleTypeList: [],
      vehicleList: '',
      total: 0,
      hotBrands: [], // 品牌
      brandList: [],
      seriesList: [], // 车系
      value: [],
      imgUrl: ''
    }
  },
  created() {
    var menuActive = this.$route.name
    if (menuActive == this.$store.state.menuActive) {
    } else {
      var keys = Object.keys(menus)
      if (keys.findIndex(item => item == menuActive) != -1) {
        this.$store.commit('setMenuActive', menuActive)
      }
    }
    this.loadData()
    this.getBrandList()
    this.getHotBrands()
    this.comm()
  },
  mounted() {
    // 获取参数
    var query = this.$route.query
    if (query.keyword) {
      this.keyword = query.keyword
    }
    if (query.price) {
      this.price = query.price
    }
    if (query.brand) {
      this.brand = query.brand
    }
    if (query.vehicleType) {
      this.vehicleType = query.vehicleType
    }
    if (query.certifyTag) {
      this.certifyTag = query.certifyTag
    }
    // 获取车辆列表
    this.getVehicleList()
  },
  methods: {
    async comm() {
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/config/index', {
        params: {
          keys: 'index_fxc_imgurl'
        }
      })
      if (data.success) {
        this.imgUrl = data.data.list[0].v
      }
    },
    async getVehicleList() {
      // this.city = sessionStorage.getItem('city')
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/vehicle/vehicleList', {
        params: {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          orders: this.orders,
          price: this.price,
          priceLow: this.priceLow,
          priceHigh: this.priceHigh,
          vehicleType: this.vehicleType,
          keyword: this.keyword,
          mileage: this.mileage,
          mileageCountLow: this.mileageCountLow,
          mileageCountHigh: this.mileageCountHigh,
          carAge: this.carAge,
          carAgeLow: this.carAgeLow,
          carAgeHigh: this.carAgeHigh,
          certifyTag: this.certifyTag,
          brand: this.brand,
          series: this.series,
          city: this.city
        }
      })
      if (data.success) {
        data.data.page.rows.forEach(item => {
          if (!item.registMonth) {
            item.registMonth = '未'
          }
          if (!item.regionName) {
            item.regionName = ''
          }
          if (item.newcarPrice) {
            item.newcarPrice = parseFloat((item.newcarPrice / 10000).toFixed(1))
          } else {
            item.newcarPrice = ''
          }
        })
        this.vehicleList = data.data.page.rows
        this.total = data.data.page.recordCount
      }
    },
    async loadData() {
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/config/commonBox', {
        params: {
          selectCode: 'carPrice,carMileage,specialArea,carAge,CarOrder,hotModel',
          isshow: 'carPrice,carMileage,specialArea,carAge,hotModel'
        }
      })
      if (data.success) {
        this.priceList = data.data.carPrice
        this.mileageList = data.data.carMileage
        this.carAgeList = data.data.carAge
        this.certifyTagList = data.data.specialArea
        this.ordersList = data.data.CarOrder
        this.vehicleTypeList = data.data.hotModel
      }
    },
    async getHotBrands() {
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/config/hotBrands')
      if (data.success) {
        this.hotBrands = data.data.list
      }
    },
    async getBrandList() {
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/config/listBrand')
      if (data.success) {
        this.brandList = data.data.list
      }
    },
    async getSeriesList(brandId) {
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/config/listSeries', {
        params: {
          brandId: brandId
        }
      })
      if (data.success) {
        this.seriesList = data.data.list
      }
    },
    handleChange() {},

    // 选择参数
    chooseParams(name, value) {
      this[name] = value

      this.pageNo = 1
      console.log(name)
      if (name == 'brand') {
        this.getSeriesList(value)
      }
      this.getVehicleList()
    },
    chooseOrders(value) {
      if (value == 'new') {
        if (this.orders == 1) {
          this.orders = 2
        } else if (this.orders == 2) {
          this.orders = 1
        } else {
          this.orders = 1
        }
      } else if (value == 'price') {
        if (this.orders == 3) {
          this.orders = 4
        } else if (this.orders == 4) {
          this.orders = 3
        } else {
          this.orders = 3
        }
      } else if (value == 'mileage') {
        if (this.orders == 5) {
          this.orders = 6
        } else if (this.orders == 6) {
          this.orders = 5
        } else {
          this.orders = 5
        }
      } else if (value == 'total') {
        this.orders = 0
      }
      this.pageNo = 1
      this.getVehicleList()
    },

    // 确认
    submit() {
      this.pageNo = 1
      this.getVehicleList()
    },
    // 清除筛选条件
    close(name) {
      this[name] = ''
      if (name == 'brand') {
        this.series = ''
        this.seriesList = []
      }
      this.pageNo = 1
      this.getVehicleList()
    },
    // 清除全部
    closeAll() {
      this.orders = 0
      this.price = 0
      this.priceLow = ''
      this.priceHigh = ''
      this.vehicleType = 0
      this.keyword = ''
      this.mileage = 0
      this.mileageCountLow = ''
      this.mileageCountHigh = ''
      this.carAge = 0
      this.carAgeLow = ''
      this.carAgeHigh = ''
      this.certifyTag = 0
      this.brand = ''
      this.series = ''

      this.seriesList = []

      this.pageNo = 1
      this.getVehicleList()
    },
    toCarDetail(tradeId) {
      this.$router.push({
        path: '/car-detail',
        query: {
          tradeId: tradeId
        }
      })
    },
    handleCurrentChange(page) {
      this.pageNo = page
      this.getVehicleList()
      window.scrollTo(0, 0)
    },
    prevPage(page) {
      this.pageNo = page
      this.getVehicleList()
      window.scrollTo(0, 0)
    },
    nextPage(page) {
      this.pageNo = page
      this.getVehicleList()
      window.scrollTo(0, 0)
    }
  },
  watch: {
    city(newName, oldName) {
      this.pageNo = 1
      this.getVehicleList()
    },
    keyword(newName, oldName) {
      this.pageNo = 1
      this.getVehicleList()
    },
    priceLow(newName, oldName) {
      var reg = /^([1-9]\d|\d)$/
      if (!reg.test(newName)) {
        this.priceLow = ''
      } else {
        this.priceLow = newName
      }
    },
    priceHigh(newName, oldName) {
      var reg = /^([1-9]\d|\d)$/
      if (!reg.test(newName)) {
        this.priceHigh = ''
      } else {
        this.priceHigh = newName
      }
    },
    mileageCountLow(newName, oldName) {
      var reg = /^([1-9]\d|\d)$/
      if (!reg.test(newName)) {
        this.mileageCountLow = ''
      } else {
        this.mileageCountLow = newName
      }
    },
    mileageCountHigh(newName, oldName) {
      var reg = /^([1-9]\d|\d)$/
      if (!reg.test(newName)) {
        this.mileageCountHigh = ''
      } else {
        this.mileageCountHigh = newName
      }
    },
    carAgeLow(newName, oldName) {
      var reg = /^([1-9]\d|\d)$/
      if (!reg.test(newName)) {
        this.carAgeLow = ''
      } else {
        this.carAgeLow = newName
      }
    },
    carAgeHigh(newName, oldName) {
      var reg = /^([1-9]\d|\d)$/
      if (!reg.test(newName)) {
        this.carAgeHigh = ''
      } else {
        this.carAgeHigh = newName
      }
    },

    // 品牌
    brand(newName, oldName) {
      this.series = ''
      this.seriesList = []

      this.pageNo = 1
      this.getVehicleList()
      this.getSeriesList(newName)
    },
    // 车系
    series(newName, oldName) {
      this.pageNo = 1
      this.getVehicleList()
    }
  },
  computed: {
    priceName: function() {
      var index = this.priceList.findIndex(item => item.value == this.price)
      if (index != -1) {
        return this.priceList[index].text
      }
      return ''
    },
    brandName: function() {
      var index = this.brandList.findIndex(item => item.id == this.brand)
      if (index != -1) {
        return this.brandList[index].name
      }
      return ''
    },
    vehicleTypeName: function() {
      var index = this.vehicleTypeList.findIndex(item => item.value == this.vehicleType)
      if (index != -1) {
        return this.vehicleTypeList[index].text
      }
      return ''
    },
    certifyTagName: function() {
      var index = this.certifyTagList.findIndex(item => item.value == this.certifyTag)
      if (index != -1) {
        return this.certifyTagList[index].text
      }
      return ''
    }
  }
}
</script>

<style lang="less" scoped>
img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.nav_bar {
  background-color: #f5f5f5;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.content {
  margin-top: 40px;
}
.filtrate {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  dl {
    display: flex;
    dt {
      background-color: #f3f6f8;
      width: 100px;
      padding: 12px 0;
      text-align: center;
      font-size: 14px;
      color: #888;
    }
    dd {
      width: 1100px;
      display: flex;
      justify-content: space-between;
      .left {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        width: 75%;
        span {
          padding: 6px 12px;
          margin: 0 6px;
          font-size: 14px;
          cursor: pointer;
        }
        img {
          width: 25px;
          height: 25px;
          object-fit: cover;
          margin: 0 15px;
        }
      }
      .right {
        display: flex;
        align-items: center;
        flex-direction: row;
        padding-right: 20px;
        span {
          padding: 0 10px;
        }
        p {
          width: 70px;
          text-align: left;
          padding-left: 10px;
        }
        .btn2 {
          text-align: center;
          background-color: #409eff;
          width: 60px;
          height: 28px;
          line-height: 28px;
          font-size: 14px;
          color: #fff;
        }
      }
    }
  }
}

.active {
  color: #fff;
  background-color: #fb6345;
}
.active2 {
  color: #fb6345;
}
.current_choose {
  margin-top: 30px;
  display: flex;
  .title {
    width: 100px;
    text-align: right;
    height: 32px;
    line-height: 30px;
  }
  .current_content {
    padding-left: 20px;
    display: flex;
    flex-wrap: wrap;
    .choose_box {
      border: 1px solid #f7917d;
      margin-right: 20px;
      margin-bottom: 10px;
      height: 30px;
      align-items: center;
      display: flex;
      :nth-child(1) {
        font-size: 14px;
        padding: 0 6px;
      }
      :nth-child(2) {
        display: flex;
        justify-content: center;
        width: 22px;
        height: 30px;
        background-color: #fa8871;
        font-size: 15px;
        line-height: 30px;
        color: #fff;
      }
    }
    .close_all {
      font-weight: 700;
      height: 32px;
      line-height: 30px;
      cursor: pointer;
    }
  }
}

.car_list {
  margin-top: 20px;
  .sort {
    display: flex;
    align-items: center;
    height: 52px;
    border-bottom: 1px solid #fb6345;
    .sort_text {
      margin: 0 20px;
      cursor: pointer;
      :nth-child(2) {
        i {
          font-weight: 700;
        }
      }
    }
    .sort_text:hover {
      color: #1989f2;
    }
  }
  .car_content {
    margin-top: 15px;
    .car_box {
      height: 295px;
      margin-bottom: 10px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      position: relative;
      .imgUrl {
        position: absolute;
        width: 3.5rem;
        height: 3.5rem;
        left: 1rem;
      }
      .car_img {
        width: 100%;
        height: 180px;
      }
      .car_name {
        white-space: nowrap; /*超出的空白区域不换行*/
        overflow: hidden; /*超出隐藏*/
        text-overflow: ellipsis; /*文本超出显示省略号*/
        padding: 0 15px;
        line-height: 2;
        font-weight: 700;
        margin-top: 15px;
      }
      .car_text {
        display: flex;
        padding: 0 15px;
        line-height: 2;
        font-size: 14px;
        color: #999;
        span {
          margin-right: 10px;
        }
      }
      .car_price {
        padding: 0 15px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #f37420;
        font-size: 18px;
        font-weight: 700;
        .dealDate {
          color: #999;
          font-size: 16px;
          font-weight: normal;
        }
      }
    }
  }
}

.page_box {
  display: flex;
  justify-content: center;
  padding: 20px;
}
</style>
